import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from "axios";
import { setEnText, setEntity, setResult } from '../audio-recorder/asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';
import { Feedback } from '../feedback';

const Translation = () => {
    const dispatch = useDispatch();
    const enText = useSelector((state) => state.asr.enText);
    const appToken = useSelector((state) => state.auth.appToken);
    
    const updateEnText = (input) => {
        dispatch(setEnText(input))
    }

    const entity = async (input) => {
        dispatch(showLoader());
        axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/api/entity`, input, {
                headers: {
                    "Content-Type": "text/plain",
                    "X-API-KEY": appToken
                },
            })
            .then((response) => {
                // handle the response
                console.log(response);
                var entity = "";
                for (var i = 0; i < response.data.slots.length; i++) {
                    entity += response.data.slots[i].entity;
                    entity += ":\t";
                    entity += response.data.slots[i].rawValue;
                    entity += ",\t\n";
                }
                dispatch(setEntity(entity));
                dispatch(setResult(response.data.userProfiles));
                dispatch(hideLoader());

            })
            .catch((error) => {
                // handle errors
                console.log(error);
                dispatch(hideLoader());
            });
    }

    return (
        <div className='translation mini-card'>
            <h4>Translation</h4>
            <div>
                <textarea
                    value={enText}
                    rows="3" style={{"width": "100%"}}
                    onChange={(e) => updateEnText(e.target.value)} />
            </div>           
            <div>
               
                <Button
                    variant="outline-dark"  size="sm" onClick={(e) => entity(enText)}>Submit</Button>
                <Feedback 
                    type = {"translate"} />
            </div>
        </div>
    );
};


export default Translation;